import React from 'react';
import { useClickable } from '../providers/ClickableProvider';
import '../styles/Footer.css';

const Footer: React.FC = () => {
    const handleAuthClick = (mode: 'login' | 'register') => {
        // Открываем модальное окно через событие
        const event = new CustomEvent('openAuthModal', { detail: { mode } });
        window.dispatchEvent(event);
    };

    const handlePlaceholderClick = (e: React.MouseEvent) => {
        e.preventDefault();
    };

    const { makeClickable } = useClickable();

    return (
        <footer className="site-footer">
            <div className="footer-content">

                {/* Логотип и описание */}
                <div className="footer-section main-section">
                    <img src="/icon.png" alt="AnimeList" className="footer-main-icon"/>
                    <div className="footer-main-text">
                        <h3 className="footer-logo">AnimeList</h3>
                        <p className="footer-description">
                            <span className="description-line">Развивающаяся база данных аниме.</span>
                            <span className="description-line">Отслеживайте просмотренное и находите новое.</span>
                        </p>
                    </div>
                </div>

                {/* Навигация */}
                <div className="footer-section">
                    <h4 className="footer-title">НАВИГАЦИЯ</h4>
                    <ul className="footer-links">
                        <li>
                            <a
                                {...makeClickable('/')}
                                style={{cursor: 'pointer'}}
                            >
                            Главная
                            </a>
                        </li>
                        <li>
                            <a
                                {...makeClickable('/anime')}
                                style={{ cursor: 'pointer' }}
                            >
                                Каталог аниме
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Пользователю */}
                <div className="footer-section">
                    <h4 className="footer-title">ПОЛЬЗОВАТЕЛЬ</h4>
                    <ul className="footer-links">
                        <li><a href="#" onClick={(e) => { e.preventDefault(); handleAuthClick('login'); }}>Авторизация</a></li>
                        <li><a href="#" onClick={(e) => { e.preventDefault(); handleAuthClick('register'); }}>Регистрация</a></li>
                    </ul>
                </div>

                {/* Информация */}
                <div className="footer-section">
                    <h4 className="footer-title">ИНФОРМАЦИЯ</h4>
                    <ul className="footer-links">
                        <li><a href="#" onClick={handlePlaceholderClick}>FAQ</a></li>
                        <li><a href="#" onClick={handlePlaceholderClick}>Правила</a></li>
                        <li><a href="#" onClick={handlePlaceholderClick}>Конфиденциальность</a></li>
                    </ul>
                </div>

            </div>

            {/* Нижняя часть футера */}
            <div className="footer-bottom">
                <div className="footer-copyright">
                    © 2026 AnimeList
                </div>
            </div>
        </footer>
    );
};

export default Footer;